<template>
  <div class="">
    <div class="row">
      <div class="col-md-4 col-12">
        <div class="form-group">
          <label>User role <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="cred.role" />
        </div>
      </div>
      <div class="col-md-4 col-12">
        <div class="form-group">
          <label>Email or username <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="cred.username"/>
        </div>
      </div>
      <div class="col-md-4 col-12">
        <div class="form-group">
          <label>Password</label>
          <input type="text" class="form-control" v-model="cred.password"/>
        </div>
      </div>
      <div class="col-12 mt-2 text-end">
		<button class="btn btn-sm btn-warning" v-on:click="addCred()">Add</button>
      </div>
    </div>
	<div class="row">
		<div class="col-12">
			<h3>Added Credentials</h3>
			<div class="table-responsive">
				<table class="table">
					<thead>
						<tr>
							<th>Role</th>
							<th>Username</th>
							<th>Password</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="c in exisintCred" :key="c.ID">
							<td>
								<input type="text" v-model="credEdit.role" v-if="showInput == c.ID">
								<span v-else>
									{{ c.role }}
								</span>
							</td>
							<td>
								<input type="text" v-model="credEdit.username" v-if="showInput == c.ID">
								<span v-else>
									{{ c.username }}
								</span>
							</td>
							<td>
								<input type="text" v-model="credEdit.password" v-if="showInput == c.ID">
								<span v-else>
									{{ c.password }}
								</span>
							</td>
							<td>
								<div v-if="showInput != c.ID">
									<a href="javascript:void(0)"
									v-on:click="showEdit(c)"
									class="text-warning">
										<i class="far fa-edit"></i>
									</a> |
									<a
										href="javascript:void(0)"
										class="text-danger"
										title="Delete"
										v-on:click="deleteCred(c.ID)"
										>
										<i class="fa fa-trash"></i>
									</a>
								</div>
								<div v-else>
									<a href="javascript:void(0)" v-on:click="saveEditedCred()">
										<i class="fa fa-save text-success"></i>
									</a> |
									<a href="javascript:void(0)" v-on:click="showInput = 0">
										<i class="fa fa-times text-danger"></i>
									</a>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
  </div>
</template>
<script>
// import { VueEditor } from "vue2-editor";
export default {
components: {
		// VueEditor
	},

	props: {
		scope_id: Number
	},

	data() {
		return {
			exisintCred: null,
			cred: {
				role: '',
				username: '',
				password: ''
			},
			credEdit: {
				id: '',
				role: '',
				username: '',
				password: ''
			},
			showInput: 0
		}
	},

	mounted() {
		this.init();
	},

	methods: {
		init: function() {
			const me = this;
			this.$axios.get(me.$server + 'organisation/' + this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/scope/' + this.scope_id + '/credential')
				.then(res => {
					if (res.data.success) {
						me.exisintCred = res.data.data;
					}
				});
		},

		showEdit: function(cred) {
			this.showInput = cred.ID;
			this.credEdit = {
					id: cred.ID,
					role: cred.role,
					username: cred.username,
					password: cred.password
				};
		},

		addCred: function() {
			const me = this;
			this.$axios.post(me.$server + 'organisation/' + this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/scope/' + this.scope_id + '/credential', me.cred)
				.then(res => {
					if (res.data.success) {
							this.$swal({
								title: res.data.message
							});
							me.cred = {
								role: '',
								username: '',
								password: ''
							}

							me.init();
						} else {
              this.$swal({
                title: res.data.message,
                icon: "error"
              });
            }
				});
		},

		deleteCred(id){
        var c = confirm("Do you really want to delete this credential?");
        if (c) {
            const me = this;
            this.$axios.delete(me.$server + 'organisation/' + this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/scope/' + this.scope_id + '/credential/' + id)
            .then(res => {
                var r = res.data;
                if (r.success) {
                    this.$swal({
											title: res.data.message
										});
                    this.init();
                }
            });
        }
    },

    saveEditedCred() {
			const me = this;

			me.credEdit.id = me.credEdit.id.toString();
			this.$axios.put(me.$server + 'organisation/' + this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/scope/' + this.scope_id + '/credential', me.credEdit)
				.then(res => {
					if (res.data.success) {
							this.$swal({
								title: res.data.message
							});
							me.showInput = 0;
							me.init();
						} else {
              this.$swal({
                title: res.data.message,
                icon: "error"
              });
            }
				});
    }
	}
}
</script>
